import React, { useState } from 'react';
import { useBlocker } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FormHeader, Page, PageLoader, TabLayout } from 'modules/ui';
import { getTalent } from '../redux';
import { TalentProfileTabs } from '../components';
import AgentsForm from './AgentsForm';
import ManagersForm from './ManagersForm';
import ConfirmationDialog from 'modules/ui/components/ConfirmationDialog/ConfirmationDialog';

export default function EditAgentsManagersPage() {
  const [agentAssignmentsTouched, setAgentAssignmentsTouched] = useState([]);
  const [managerAssignmentsTouched, setManagerAssignmentsTouched] = useState(
    [],
  );

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      (agentAssignmentsTouched.length > 0 ||
        managerAssignmentsTouched.length > 0) &&
      nextLocation.pathname !== currentLocation.pathname,
  );

  const talent = useSelector(getTalent);

  if (!talent) {
    return <PageLoader />;
  }

  return (
    <Page>
      <TabLayout tabs={<TalentProfileTabs />}>
        <FormHeader
          title="Agents and Managers"
          description="Keep your agents and managers up to date"
        />
        <AgentsForm
          talentId={talent.id}
          agentAssignmentsTouched={agentAssignmentsTouched}
          setAgentAssignmentsTouched={setAgentAssignmentsTouched}
        />
        <ManagersForm
          talentId={talent.id}
          managerAssignmentsTouched={managerAssignmentsTouched}
          setManagerAssignmentsTouched={setManagerAssignmentsTouched}
        />
        {blocker.state === 'blocked' && (
          <div className="modalContainer">
            <ConfirmationDialog
              title="Discard changes?"
              message="Changes made to this section won’t be saved unless you hit the save button at the bottom of the page."
              actionBtnLabel="Discard changes"
              cancelBtnLabel="Keep editing"
              onCancel={() => blocker.reset()}
              onAction={() => blocker.proceed()}
            />
          </div>
        )}
      </TabLayout>
    </Page>
  );
}
